export default function Loading() {
	return (
		<div className="d-flex justify-content-center">
			<div className="spinner-border"/>
		</div>
	)
}